import React from "react";

function ExitFullScreenPopup({
  handleSubmit,
  toggleFullScreen,
  setDidPressExit,
}) {
  return (
    <div className="ContainerSubmitedSucess ">
      <div className="SubContainerSubmitedSucess">
        <div className="d-flex justify-content-center align-items-center">
          <img src="/images/alert.svg" alt="" />
        </div>
        <div className="d-flex justify-content-center align-items-center mt-4 sucessMsg20">
          You have to submit your assessment before you exit the screen!{" "}
        </div>
        <div className="d-flex justify-content-center align-items-center mt-2 sucessMsg2">
          Do you want to submit the assessment?{" "}
        </div>
        <div className="d-flex justify-content-around align-items-center mt-3 widthOfContainer">
          <button
            className="okayBtnsucessBack"
            onClick={() => {
              handleSubmit();
              setDidPressExit(false);
            }}
          >
            Submit
          </button>
          <button
            className="okayBtnsucess"
            onClick={() => {
              toggleFullScreen();
              setDidPressExit(false);
            }}
          >
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
}

export default ExitFullScreenPopup;
